export default {
  path: ":alias/users",
  component: resolve => require(["@/views/users"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/users/list"], resolve)
    }
  ]
};
